import { Component, OnInit } from '@angular/core';
import { AlertController, NavController, ToastController } from '@ionic/angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { UtilService } from '../../../service/util.service';
import { environment } from '../../../../environments/environment';
import { UserProfile } from '../../../models/user-profile.model';
import { RoleAccess } from '../../../models/role-access.model';
import { UserData } from '../../../providers/user-data';
import { Router } from '@angular/router';

@Component({
  selector: 'app-customer-create',
  templateUrl: './customer-create.page.html',
  styleUrls: ['./customer-create.page.scss'],
})
export class CustomerCreatePage implements OnInit {

  baseUrl: any;
  token: any;
  formCustomerCreate: FormGroup;
  userProfile: UserProfile = new UserProfile();
  roleAccess = new RoleAccess();
  countryData:any[]=[];
  cityData:any[]=[];
  districtData:any[]=[];
  subdistrictData:any[]=[];
  provinceData:any[]=[];
  counterData:any[]=[];
  countryId:any=0;
  provinceId:any=0;
  cityId:any=0;
  districtId:any=0;
  subdistrictId:any=0;
  counterId:any=0;
  
  selectedProvince:any[]=[];
  selectedCity:any[]=[];
  selectedDistrict:any[]=[];
  selectedSubdistrict:any[]=[];
  maxDate:any=[];
  minDate:any=[];
  isProvinceRequired:boolean=false;

  constructor(
    private fb: FormBuilder,
    private storage: Storage,
    private http: HttpClient,
    private utilService: UtilService,
    private alertController: AlertController,
    private toastCtrl: ToastController,
    private navCtrl: NavController,
    private userData: UserData,
    private router: Router
  ) {
    this.baseUrl = environment.apiUrl;
  }

  ngOnInit() {
    this.buildFormCustomerCreate();
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.roleAccess = this.userData.checkAccess(this.router.url, access, this.userProfile);
        if(!this.roleAccess || this.roleAccess.create!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
          this.navCtrl.navigateForward(['/']);
        }
        const today = new Date();
        const tenYearsAgo = new Date();
        const oneHundredYearsAgo = new Date();
        tenYearsAgo.setFullYear(today.getFullYear() - 10);
        oneHundredYearsAgo.setFullYear(today.getFullYear() - 100);
        this.maxDate = tenYearsAgo.toISOString().split('T')[0];
        this.minDate = oneHundredYearsAgo.toISOString().split('T')[0];
      }
    });
  }

  buildFormCustomerCreate() {
    this.getCountry();
    this.formCustomerCreate = this.fb.group({
      customerName: [null,  [
            Validators.required,
            Validators.pattern(/^[A-Za-z]+(?: [A-Za-z]+)*$/)
        ]
      ],
      identityNumber: [null],
      phone: [null, [Validators.required, Validators.pattern(/^(\+|08)[0-9]*$/),]],
      email: [null, [Validators.required,Validators.email]],
      birthPlace: [null],
      birthDate:[null],
      gender:[null],
      profession:[null],
      address:[null],
      receiptNo:[null],
      country:[null, Validators.required],
      province:[null],
      city:[null],
      district:[null],
      subdistrict:[null],
      counter:[null]
    });
    
    var countryControl = this.formCustomerCreate.get('country');
    var provinceControl = this.formCustomerCreate.get('province');
    if (countryControl && provinceControl) {
      countryControl.valueChanges.subscribe(function(value) {
        if (value == 103) {
          provinceControl.setValidators([Validators.required]);
          this.isProvinceRequired = true;
        } else {
          provinceControl.clearValidators();
          this.isProvinceRequired = false;
        }
        provinceControl.updateValueAndValidity();
      });
    }
  }

  numberOnlyValidation(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      // invalid character, prevent input
      event.preventDefault();
    }
  }

  getCountry() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      const customerData = this.formCustomerCreate.getRawValue();
      const paramsOpts = new HttpParams()
        .set('token', this.token)
      const reqOpts = new HttpHeaders()
        .set('Accept', 'application/json');
      this.http.get(this.baseUrl + 'customer/create', { headers: reqOpts, params: paramsOpts })
      .subscribe((response: any) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 200) {
          this.countryData =response.results.country;
          this.provinceData =response.results.province;
          this.cityData =response.results.city;
          this.districtData =response.results.district;
          this.subdistrictData =response.results.subdistrict;
          this.counterData = response.results.counter;
        }else {
          this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error' }).then(t => t.present());
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      })
    });
  }
  inputCustomer() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      const customerData = this.formCustomerCreate.getRawValue();

      const paramsOpts = new HttpParams()
        .set('token', this.token)

      let receiptNo = customerData.receiptNo ?  customerData.receiptNo : '';
      let birthPlace = customerData.birthPlace ?  customerData.birthPlace : '';
      let birthDate = customerData.birthDate ?  customerData.birthDate : '';
      let gender = customerData.gender ?  customerData.gender : '';
      let profession = customerData.profession ?  customerData.profession : '';
      let address = customerData.address ?  customerData.address : '';
      let customerName = customerData.customerName ?  customerData.customerName : '';
      let identityNumber = customerData.identityNumber ?  customerData.identityNumber : '';
      let email = customerData.email ?  customerData.email : '';
      const reqOpts = new HttpHeaders()
        .set('Accept', 'application/json'),
      formData = new FormData();
      formData.append('customer_name', customerName);
      formData.append('identity_number', identityNumber);
      formData.append('phone', customerData.phone);
      formData.append('email', email);
      formData.append('created_by', this.userProfile.username);
      formData.append('birth_place', birthPlace);
      formData.append('birth_date', birthDate);
      formData.append('gender', gender);
      formData.append('profession', profession);
      formData.append('addres', address);
      formData.append('customer_type_id', '1');
      formData.append('receipt_no',receiptNo);
      formData.append('country_id',this.countryId);
      formData.append('province_id',this.provinceId);
      formData.append('city_id',this.cityId);
      formData.append('district_id', this.districtId);
      formData.append('subdistrict_id', this.subdistrictId);
      formData.append('registration_counter',this.counterId)

      this.http.post(this.baseUrl + 'customer', formData, { headers: reqOpts, params: paramsOpts })
      .subscribe((response: any) => {
        this.utilService.loadingDismiss();
        if(response.status.code === 201) {
          this.showConfirmInput();
        }
        else if(response.status.code === 202) {
          this.toastCtrl.create({ duration: 2000, message: response.message }).then(t => t.present());
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Terdapat Error' }).then(t => t.present());
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      })
    });
  }

  async showConfirmInput() {
    const alert = await this.alertController.create({
      header: 'Notification',
      cssClass:'custom-alert-class',
      message: 'Data sudah tersimpan!',
      buttons: [
        {
          text: 'OK',
          handler: () => {
            this.navCtrl.navigateForward(['/customer']);;
          }
        }
      ]
    });

    await alert.present();
  }

  selectCountry(event){
    this.countryId = event.value.id;
    this.provinceId ='';
    this.selectedProvince=[];
    this.formCustomerCreate.get('province').reset();
    this.cityId ='';
    this.formCustomerCreate.get('city').reset();
    this.districtId ='';
    this.formCustomerCreate.get('district').reset();
    this.subdistrictId ='';
    this.formCustomerCreate.get('subdistrict').reset();
    this.filterProvinceByCountry();
        
    var provinceControl = this.formCustomerCreate.get('province');
    if (this.countryId  == 103) {
      provinceControl.setValidators([Validators.required]);
      this.isProvinceRequired = true;
    } else {
      provinceControl.clearValidators();
      this.isProvinceRequired = false;
    }
    provinceControl.updateValueAndValidity();
  }
  filterProvinceByCountry(){
    this.selectedCity=[];
    this.selectedDistrict=[];
    this.selectedSubdistrict=[];
    this.selectedProvince = this.provinceData.filter(x=>x.country_id==this.countryId);
  }
  selectProvince(event){
    this.provinceId = event.value.id;
    this.cityId ='';
    this.districtId ='';
    this.subdistrictId ='';
    this.filterCityByProvince();
  }
  filterCityByProvince(){
    this.selectedDistrict=[];
    this.selectedSubdistrict=[];
    this.selectedCity = this.cityData.filter(x=>x.province_id==this.provinceId);
  }
  selectCity(event){
    this.cityId = event.value.id;
    this.districtId ='';
    this.subdistrictId ='';
    this.filterDistrictByCity();
  }
  filterDistrictByCity(){
    this.selectedSubdistrict=[];
    this.selectedDistrict = this.districtData.filter(x=>x.city_id==this.cityId);
  }
  selectDistrict(event){
    this.districtId = event.value.id;
    this.subdistrictId ='';
    this.filterSubdistrictByDistrict();
  }
  filterSubdistrictByDistrict(){
    this.selectedSubdistrict = this.subdistrictData.filter(x=>x.district_id==this.districtId);
  }
  selectSubdistrict(event){
    this.subdistrictId = event.value.id;
  }
  selectCounter(event){
    this.counterId = event.value.id;
  }
  
  phoneNumberValidation(event: any) {
    const input = event.target as HTMLInputElement;
    const inputChar = String.fromCharCode(event.charCode);

    // Allow angka
    if (/[0-9]/.test(inputChar)) {
      return;
    }

    // Allow "+" hanya jika:
    // - karakter adalah "+"
    // - posisi cursor di index 0
    // - belum ada "+" sebelumnya
    if (
      inputChar === '+' &&
      input.selectionStart === 0 &&
      !input.value.includes('+')
    ) {
      return;
    }

    // Selain itu ditolak
    event.preventDefault();
  }
  validateCustomerName(event: any) {
    const value = event.target.value || '';
    const cleanValue = value.replace(/[^A-Za-z ]/g, '');
    event.target.value = cleanValue;
    this.formCustomerCreate
        .get('customerName')
        .setValue(cleanValue, { emitEvent: false });
  }
}
